import cls from "classnames"
import React, {CSSProperties, useState} from "react"

interface ComponentLoaderProps {
  id: string,
  name?: string | undefined
  inline?: boolean
}

export const ComponentLoaderLoadingText = 'Loading...'

const ComponentLoader = ({id, inline = false}: ComponentLoaderProps) => {

  const [text] = useState(ComponentLoaderLoadingText)

  const CompLoadingStyle: CSSProperties = {
    display: 'flex',
    flexDirection: inline ? 'row' : 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
  }
  return (
    <div style={CompLoadingStyle} className={cls('component-loading', {'inline': inline})} id={id}>
      <div>{text}</div>
      <div className="lds-ellipsis">
        <div/>
        <div/>
        <div/>
        <div/>
      </div>
    </div>
  )
}

export default ComponentLoader
